import { useEffect, useState } from "react";
import Api from "../../services/api";
import { randomProfilePic } from "../../utils/profile/utils";

export const useProfilePic = (userID: string) => {
  const [picUrl, setPicUrl] = useState<string>();

  useEffect(() => {
    if (userID) {
      const api = new Api();

      api
        .getProfilePicUrl(userID)
        .then((response) => {
          setPicUrl(response);
        })
        .catch((error) => {
          setPicUrl(randomProfilePic(userID));
        });
    }
  }, [userID]);

  return picUrl;
};
